//#region Imports Packages and Libs

import { Component, Prop, Vue } from "vue-facing-decorator";
import Img from "../../components/image.vue";
import { FORM_COMPONENT_TYPE } from "../../enums";
import type { FormHeaderComponent } from "../../types/forms";
import { Util } from "../../util";

//#endregion

//#region Define the component in class-style

@Component({
	components: { Img },
})
export default class FormHeader extends Vue {
	//#region Class properties will be component data

	@Prop() components?: FormHeaderComponent[];

	//#endregion

	//#region Computed Properties

	get prefixClassName() {
		return this.$store.state.prefixClassName || "";
	}

	//#endregion

	//#region Main Methods

	decodeTags(content: string = "") {
		return content.replace(/&amp;/g, "&").replace(/&amp;/g, "&");
	}

	/**
	 * This method is used to create a computed property that returns the font style for the header text.
	 */
	get computedFontStyle() {
		return Util.getFontStyle(this.components, FORM_COMPONENT_TYPE.HeaderText);
	}

	//#endregion
}

//#endregion
